import React from 'react';
import { Skeleton } from 'antd';
import { number } from 'prop-types';

const SkeletonLoading = ({ rows = 4 }) => (
  <div className="suspense-skeleton">
    <Skeleton active paragraph={{ rows }} />
  </div>
);

SkeletonLoading.propTypes = {
  rows: number,
};

export default SkeletonLoading;
